export default {
  DELIVERED: "delivered",
  WON: "won",
  QUOTED: "quoted",
  IN_PROGRESS: "in_progress",
  LOST: "lost",
  OPENED: "opened",
  INVITED: "invited",
  NOT_INVITED: "not_invited",
  DECLINED: "declined",
  CANCELED: "canceled",
} as const;
